<template>
  <BaseDropdown
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <template v-slot:placeholder>
      <UserImagePrimary
        :disableLink="true"
        :size="dropdownImageSize"
        :tenantUser="tenantUser"
        :style="style.dropdownImage"
      />
    </template>
    <template v-slot:selection>
      <UserImagePrimary
        :disableLink="true"
        :size="dropdownImageSize"
        :tenantUser="tenantUser"
        :style="style.dropdownImage"
      />
    </template>
    <template v-slot:expand-symbol-right>
      <GoogleMaterialIconPrimary
        :content="'expand_more'"
        :fontSize="iconFontSize"
        :style="style.icon"
      />
    </template>
    <template v-slot:dropdown-top>
      <div :style="style.userInfo">
        <UserImagePrimary
          :disableLink="true"
          :size="userImageSize"
          :tenantUser="tenantUser"
        />
        <div :style="style.userText">
          <HeaderMediumPrimary
            :truncate="true"
            :style="style.name"
          >
            {{ firstName }} {{ lastName }}
          </HeaderMediumPrimary>
          <TextEmailMuted
            :truncate="true"
            :style="style.email"
          >
            {{ email }}
          </TextEmailMuted>
        </div>
      </div>
    </template>
    <template v-slot:option="props">
      <div>
        {{ props.label }}
      </div>
      <GoogleMaterialIconPrimary
        v-if="props.option.locked"
        :content="'lock'"
        :fontSize="styleVariable.icon.lock.fontSize"
        :style="style.iconLock"
      />
    </template>
  </BaseDropdown>
</template>

<script>
  import BaseDropdown from '@base/v2/base-dropdown'
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import TextEmailMuted from '@modules/v2/text/text-email-muted'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserDropdownPrimary',
    inheritAttrs: false,
    components: {
      BaseDropdown,
      GoogleMaterialIconPrimary,
      HeaderMediumPrimary,
      TextEmailMuted,
      UserImagePrimary,
    },
    props: {
      tenantUser: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        dropdownImageSize: '32px',
        iconFontSize: '20px',
        userImageSize: '40px',
        styleVariable: {
          icon: {
            lock: {
              fontSize: '16px',
            },
          },
        },
        style: {
          dropdownImage: {
            margin: `0 ${Layout.space.xs} 0 ${Layout.space.md}`,
          },
          email: {
            height: '18px',
          },
          icon: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
          },
          iconLock: {
            margin: `0 0 0 ${Layout.space.xs}`,
          },
          name: {
            height: '18px',
          },
          userInfo: {
            alignItems: 'center',
            display: 'flex',
            height: '40xp',
            justifyContent: 'space-between',
            margin: `0 0 ${Layout.space.sm}`,
            padding: `0 ${Layout.space.md}`,
          },
          userText: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '40px',
            padding: `0 0 0 ${Layout.space.sm}`,
            width: 'calc(100% - 48px)',
          },
        },
        styleConfig: {
          actionSymbol: {},
          container: {},
          dropdown: {
            borderRadius: Layout.space.sm,
            padding: `${Layout.space.sm} 0`,
            margin: `${Layout.space.sm} 0 0 0`,
            minWidth: '256px',
          },
          dropdownList: {
            overflow: 'none',
          },
          expandSymbol: {},
          option: {
            alignItems: 'center',
            display: 'flex',
            padding: `0 ${Layout.space.md}`,
          },
          placeholder: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
          },
          row: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            height: '32px',
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            width: '100%',
          },
          selectionContainer: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
          },
          selection: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
          },
          selectSymbol: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.dropdown,
        {
          left: '-185px',
          backgroundColor: this.color.light1(),
          border: `solid ${this.color.dark4()}`,
          borderWidth: '1px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
        },
      );
      Object.assign(
        this.styleConfig.row,
        {
          backgroundColor: {
            '': 'transparent',
            hover: this.color.dark6(),
            active: this.color.dark6(),
            disabled: this.color.dark4(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      email: function () {
        return this.tenantUser?.user?.email;
      },
      firstName: function () {
        return this.tenantUser?.user?.firstName;
      },
      lastName: function () {
        return this.tenantUser?.user?.lastName;
      },
    },
  };
</script>
